import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Main from "./components/Main";

function App() {
  const {
    isLoading,
    isAuthenticated,
    error,
    loginWithRedirect,
    logout,
    getAccessTokenSilently,
  } = useAuth0();

  useEffect(() => {
    const handleAuthentication = async () => {
      if (!isAuthenticated && !isLoading) {
        try {
          await loginWithRedirect({
            appState: { returnTo: window.location.href }, 
          });
        } catch (err) {
          console.error("Error during login redirect:", err);
        }
      }
    };

    handleAuthentication();
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  if (error) {
    return <h1>Laddar cready...</h1>;
  }

  if (isAuthenticated) {
    return <Main />;
  }

  // Clear local storage and render the login screen for unauthenticated users
  window.localStorage.clear();

  return (
    <div className="relative bg-white">
      <div className="mx-auto max-w-7xl lg:grid lg:grid-cols-12 lg:gap-x-8 lg:px-8">
        <div className="px-6 pb-24 pt-10 sm:pb-32 lg:col-span-7 lg:px-0 lg:pb-56 lg:pt-40 xl:col-span-6">
          <div className="mx-auto max-w-2xl lg:mx-0">
            <img className="h-16" src="logo.png" alt="cready" />
            <h1 className="mt-24 text-4xl font-bold tracking-tight text-gray-900 sm:mt-10 sm:text-6xl">
              Kundportal
            </h1>
            <div className="hidden sm:mt-32 sm:flex lg:mt-16">
              <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-500 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                Är du inte kund? Klicka här för att kontakta oss{" "}
                <a
                  href="https://www.cready.se/"
                  className="whitespace-nowrap font-semibold text-indigo-600"
                >
                  <span className="absolute inset-0" aria-hidden="true" />
                  cready.se <span aria-hidden="true">&rarr;</span>
                </a>
              </div>
            </div>
            <div className="mt-10 flex items-center gap-x-6">
              <a
                href="#"
                onClick={() => loginWithRedirect()}
                className="block px-6 py-2.5 mb-10 text-sm font-semibold text-center hover:text-blue-1 bg-blue-1 align-middle transition-all duration-100 ease-in-out hover:bg-transparent border-2 border-blue-1 border-solid rounded-md cursor-pointer text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1">
                  Logga in
              </a>
            </div>
          </div>
        </div>
        <div className="relative lg:col-span-5 lg:-mr-8 xl:absolute xl:inset-0 xl:left-1/2 xl:mr-0">
          <img
            className="aspect-[3/2] w-full bg-gray-50 object-cover lg:absolute lg:inset-0 lg:aspect-auto lg:h-full"
            src="https://images.unsplash.com/photo-1582139329536-e7284fece509?q=80&w=2757&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

export default App;
